import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { stats } from '@/mocks/site';

const quickTags = ['直播电商', '粉丝经济', '品牌分家', '信息传播', '怀旧营销'];

export default function HomeHero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : '/topics');
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20amber%20editorial%20abstract%20scene%20of%20scattered%20documents%20magnifier%20and%20thread%20connections%20on%20a%20dark%20cream%20surface%2C%20investigation%20mood%2C%20dramatic%20side%20lighting%2C%20deep%20green%20shadows%2C%20high%20detail%20cinematic&width=1800&height=1000&seq=bl-hero-01&orientation=landscape"
          alt="爆料看料深扒观察室 - 深度拆解公开事件背后的逻辑"
          title="爆料看料 - 深扒本质 理性看料"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/75" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col px-4 pb-16 pt-20 md:px-8 md:pb-24 md:pt-28">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
          <i className="ri-alarm-warning-line text-secondary-300" />
          基于公开信息 · 拒绝谣言 · 理性拆解
        </span>

        <h2 className="font-heading mt-6 max-w-3xl text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-[3.4rem]">
          爆料看料，
          <br className="hidden sm:block" />
          深扒每一条料背后的真相
        </h2>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          我们不抢第一现场，只做更慢的那一步：起底事件的来龙去脉，拆解复杂关系与隐藏细节，标注每一条信息的来源，
          让你穿透表象，自己看见核心。
        </p>

        <form onSubmit={handleSearch} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-500" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索事件、品牌或关键词，例如「退货率」"
              aria-label="站内搜索"
              className="w-full rounded-md border border-background-100/20 bg-background-50/95 py-3.5 pl-11 pr-4 text-sm text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始深扒
          </button>
        </form>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-xs text-background-300">热门：</span>
          {quickTags.map((tag) => (
            <Link
              key={tag}
              to={`/topics?q=${encodeURIComponent(tag)}`}
              className="whitespace-nowrap rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-200 transition-colors hover:border-primary-300 hover:text-background-50"
            >
              {tag}
            </Link>
          ))}
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-6 border-t border-background-100/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</dt>
              <dd className="mt-1 text-xs text-background-300 md:text-sm">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}